import React from 'react'
import { useParams } from 'react-router-dom'
import { useScreenShareParticipant } from '@gopeerproject/web-kit'

import { NextModal as Modal, Text } from '@components/UI'

const ScreenShareModal = ({ close }) => {
  const isScreenSharesupported =
    navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia
  const screenShareParticipant = useScreenShareParticipant()
  const { id } = useParams()

  return (
    <Modal
      className='fullscreen'
      title='Unable to Share Screen'
      close={() => close()}
    >
      {!isScreenSharesupported ? (
        <Text style={{ maxWidth: '100%', width: 440 }}>
          As it seems your browser does not support screen sharing. Please, try
          different browser or contact our customer support for additional tips.
        </Text>
      ) : screenShareParticipant ? (
        <Text style={{ maxWidth: '100%', width: 440 }}>
          Someone else seems to be sharing screen already. Only one participant
          can share screen at a time.
        </Text>
      ) : id ? null : (
        <Text style={{ maxWidth: '100%', width: 440 }}>
          Screen sharing is not supported in the Practice Classroom, but you
          will be able to screen share in the GoPeer Classroom during your
          actual lesson. Contact support to learn more.
        </Text>
      )}
    </Modal>
  )
}

export default ScreenShareModal
